import { Outlet } from 'react-router-dom';

import Sidebar from 'src/layouts/Sidebar';
import AppHeader from 'src/layouts/AppHeader';

const SidebarLayout = () => {
  return (
    <>
      <Sidebar />
      <AppHeader />
      <Outlet />
    </>
  );
};

export default SidebarLayout;
